import React from 'react';
import { connect } from 'react-redux';
import { DBSpecDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestMuscleToneRLowerTrunk extends React.Component {

    render() {
        return (
            <div key={this.props.panelId} className={styles.dropdown_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Muscle Tone - R Lower Trunk'/>
                <span className={styles.spacer} />
                <label className={styles.label}>R Lower Trunk</label>
                <span className={styles.r} />
                <DBSpecDropDownObjective
                    field='TSMUSCLOWTRUNKR'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.c}
                    optionsValue={5}
                />
                <span className={styles.l} />
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSMUSCLOWTRUNKR !== null &&
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSMUSCLOWTRUNKR !== 'WNL'
            ? true : false,
    };
}

const connectedSpecialTestMuscleToneRLowerTrunk = connect(mapStateToProps)(SpecialTestMuscleToneRLowerTrunk);
export { connectedSpecialTestMuscleToneRLowerTrunk as SpecialTestMuscleToneRLowerTrunk };


